import Cta from '@atoms/Cta/Cta';
import Image from '@atoms/Image/Image';
import { LikeButtonVariants } from '@atoms/LikeButton/LikeButton';
import Text from '@atoms/Text/Text';
import CardTypeEnum from '@models/enums/CardTypeEnum';
import { IProductHero } from '@models/IProductHero';
import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';

const ProductHero = ({ heading, image, links, id, ...rest }: IProductHero) => (
  <section className="tw-mb-16 tw-flex tw-max-h-[810px] tw-flex-col tw-justify-center tw-bg-grey-10 tw-py-10 md:tw-mb-20 md:tw-min-h-[424px] md:tw-py-12">
    <div className="b2b-container tw-grid tw-w-full tw-grid-cols-6 md:tw-gap-8">
      <div className="tw-col-span-6 tw-my-auto md:tw-col-span-4">
        <Text variant="hero-headline" as="h1" className="tw-mb-6">
          {heading}
        </Text>
        <div className="tw-min-h-6">
          <AddToMyListButton
            {...rest}
            cardId={id}
            collection={CardTypeEnum.Products}
            buttonVariant={LikeButtonVariants.Inline}
            gtmTrackingEvents={{
              standardNameId: id,
              heading,
              displayCategory: rest.displayCategory,
            }}
          />
        </div>
        {links && links.length > 0 && (
          <div className="tw-mt-14 tw-flex tw-flex-col tw-gap-4">
            {links.map((link) => (
              <div key={link.url} className="tw-flex">
                <Cta {...link} />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="-tw-order-1 tw-col-span-6 tw-aspect-[16/10] tw-content-center max-md:tw-px-[26px] max-md:tw-py-4 md:tw-order-1 md:tw-col-span-2">
        <Image image={image} classes="tw-w-full" />
      </div>
    </div>
  </section>
);

export default ProductHero;
